module.exports = __webpack_public_path__ + "img/the sun evolution 2-01.0e408a73.png";